import type { InstalledApp } from '../hooks/useAppSystem';

export function getAllInstalledApps(
  coreApps: InstalledApp[],
  installedAddons: InstalledApp[]
): InstalledApp[] {
  return [...coreApps, ...installedAddons];
}

export function isAppInstalled(
  slug: string,
  coreApps: InstalledApp[],
  installedAddons: InstalledApp[]
): boolean {
  return getAllInstalledApps(coreApps, installedAddons).some(
    (installed) => installed.app?.slug === slug && installed.status === 'active'
  );
}

export function getInstalledAppBySlug(
  slug: string,
  coreApps: InstalledApp[],
  installedAddons: InstalledApp[]
): InstalledApp | undefined {
  return getAllInstalledApps(coreApps, installedAddons).find(
    (installed) => installed.app?.slug === slug && installed.status === 'active'
  );
}
